import { useMemo } from 'react';
import { PaymentInfo } from '@/types/payment.type';

export const usePaymentsData = (payments: PaymentInfo[]) => {
  const validPayments = useMemo(() => {
    return payments.filter(payment =>
      payment.status !== 'Inativo' && payment.status !== 'RECEIVED'
    );
  }, [payments]);

  const allPaymentsData = useMemo(() => {
    const paymentsId: string[] = [];
    const externalPaymentIds: string[] = [];

    payments.forEach(payment => {
      if (payment._id) {
        paymentsId.push(payment._id);
      }
      if (payment.externalPaymentId) {
        externalPaymentIds.push(payment.externalPaymentId);
      }
    });

    return {
      paymentsId,
      externalPaymentIds,
    };
  }, [payments]);

  return {
    validPayments,
    allPaymentsData
  };
};
